export default __webpack_public_path__ + "c2b443b5d3c1e95c719f5c7fa8f05fa4.wasm";